export const validate = (value, validations = []) => {
  for (let v of validations) {
    if (!v.test(value)) {
      return v.message;
    }
  }
  return null;
};
